module.exports = __webpack_public_path__ + "img/9791159252983.65934857.jpg";